import { render } from "./AposAreaContextualMenu.vue?vue&type=template&id=78146354&scoped=true"
import script from "./AposAreaContextualMenu.vue?vue&type=script&lang=js"
export * from "./AposAreaContextualMenu.vue?vue&type=script&lang=js"

import "./AposAreaContextualMenu.vue?vue&type=style&index=0&id=78146354&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78146354"],['__file',"area/ui/apos/components/AposAreaContextualMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78146354"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78146354', __exports__)) {
    api.reload('78146354', __exports__)
  }
  
  module.hot.accept("./AposAreaContextualMenu.vue?vue&type=template&id=78146354&scoped=true", () => {
    api.rerender('78146354', render)
  })

}


export default __exports__